import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { useStore } from '../../store';
import { getMostRelevantCard } from '../../helpers/cardStatus.helper';

export const useMyLiliCardQuery = (onError: () => void) => {
  const { customerId } = useStore(state => state.currUser());
  const { getPersonalAccount } = useStore(state => state);

  return useQuery(
    'myLiliCard',
    async () => {
      let cardId = '';
      const mostRelevantCard = getMostRelevantCard(getPersonalAccount().cards);
      if (mostRelevantCard) {
        cardId = mostRelevantCard?.cardId;
      }
      const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/card/${cardId}/image`);
      return data.url;
    },
    {
      enabled: false,
      onError: () => onError(),
      cacheTime: 0,
      retry: 1,
    },
  );
};
